<template>
  <div class="border-box-1" :ref="ref">
    <svg class="border-svg-container" :width="mergedWidth" :height="height">
      <defs>
        <linearGradient id="grad1" x1="50%" y1="100%" x2="100%" y2="10%">
          <stop offset="0" :stop-color="mergedColor[0]" stop-opacity="0.722"/>
          <stop offset="1" :stop-color="mergedColor[0]" stop-opacity="0"/>
        </linearGradient>
      </defs>
      <path :d="`M 5 ${height / 3 - 20} L 5 5  L ${mergedWidth - 25} 5 L ${mergedWidth - 5} 25 L ${mergedWidth - 5} ${height - 5} L 5 ${height -5 } L 5 ${height / 3 + 20} L 15 ${height / 3 + 10} L 15 ${height / 3 - 15}`" :fill="backgroundColor" :stroke="mergedColor[0]"/>
      <path :d="`M ${mergedWidth - 28},7 l 20.954,20 v 7 l-27.938-27 h 6.984 Z`" :fill="mergedColor[0]" fill-opacity="0.14" fill-rule="evenodd"/>
      <rect :x="14" :y="`${height / 3 - 16}`" width="2" height="2" rx="1" ry="1" :fill="mergedColor[0]" :stroke="mergedColor[0]"/>
      <!--<path :d="`M ${(mergedWidth - 20) /3 -5} 5 L ${(mergedWidth - 20) /3 +5}  5`" :stroke="backgroundColor"/>-->
      <!--<rect :x="`${(mergedWidth - 20) / 3 }`" y="4" width="2" height="2" rx="1" ry="1" :fill="mergedColor[0]" :stroke="mergedColor[0]"/>
      <rect :x="`${(mergedWidth - 20) / 3 + 10}`" y="4" width="2" height="2" rx="1" ry="1" :fill="mergedColor[0]" :stroke="mergedColor[0]"/>-->
      <path :d="`M ${mergedWidth - 20} 5 L ${mergedWidth - 5} 5 L ${mergedWidth -5} 20 L ${mergedWidth -20} 5`" :fill="mergedColor[0]" :stroke="mergedColor[0]"/>
      <path :d="`M ${mergedWidth - 5} ${height - 15} L ${mergedWidth - 5} ${height - 5} L ${mergedWidth - 15} ${height - 5}`" fill="transparent" :stroke="mergedColor[1]" stroke-width="2px"/>
      <path :d="`M 5 ${height - 15} L 5 ${height - 5} L 15 ${height - 5}`" fill="transparent" :stroke="mergedColor[1]" stroke-width="2px"/>
      <g>
        <path :d="`M 0,${height /3 - 10} l 10-8 v 4 l-10,8 v -4 Z`" fill="url(#grad1)"/>
        <path :d="`M 0,${height /3 - 10 + 8} l 10-8 v 4 l-10,8 v -4 Z`" fill="url(#grad1)"/>
        <path :d="`M 0,${height /3 - 10 + 16} l 10-8 v 4 l-10,8 v -4 Z`" fill="url(#grad1)"/>
        <path :d="`M 0,${height /3 - 10 + 24} l 10-8 v 4 l-10,8 v -4 Z`" fill="url(#grad1)"/>
      </g>
    </svg>
    <div class="border-box-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import autoResize from '@jiaminghi/data-view/src/mixin/autoResize'
import { deepMerge } from '@jiaminghi/charts/lib/util/index'
import { deepClone } from '@jiaminghi/c-render/lib/plugin/util'

export default {
  name: 'BorderBox1',
  mixins: [autoResize],
  props: {
    color: {
      type: Array,
      default: () => ([]),
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    boxWidth: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      ref: 'border-box-1',
      defaultColor: ['#00d4ff','#2cf7fe'],
      mergedColor: [],
      mergedWidth: 0,
    }
  },
  watch: {
    color() {
      const {mergeColor} = this
      mergeColor()
    },
    width: {
      deep: true,
      immediate: true,
      handler(value) {
        if (!this.boxWidth) {
          this.mergedWidth = this.width
        }
      }
    },
    boxWidth:{
      deep:true,
      immediate:true,
      handler(value) {
        if (value) {
          this.mergedWidth = value
        }
      }
    }
  },
  methods: {
    mergeColor() {
      const {color, defaultColor} = this
      this.mergedColor = deepMerge(deepClone(defaultColor, true), color || [])
    }
  },
  mounted() {
    const {mergeColor}=this
    mergeColor()
    //this.mergedWidth = this.width
  }
}
</script>

<style lang="less">
.border-box-1{
  position: relative;
  width: 100%;
  height: 100%;

  .border-svg-container{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
  }
  .border-box-content{
    position: relative;
    width: 100%;
    height: 100%;
    padding: 10px;
    .ivu-modal-confirm-head-title,.el-tree__empty-text{
      color: #00d5ff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/border/border-box-1/main.vue